import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.polyfills';

const Gumshoe = require('gumshoejs');

const scroll = () => {
  const header = document.querySelector('.c-header');
  // eslint-disable-next-line no-unused-vars
  const scroller = new SmoothScroll('.c-anchornav a', {
    speed: 300,
    offset() {
      return header.getBoundingClientRect().height + 20;
    },
    topOnEmptyHash: false,
    updateURL: false,
    popstate: false,
  });
};

const scrollspy = () => {
  const anchorNav = document.querySelector('.c-anchornav');
  const header = document.querySelector('.c-header');

  if (anchorNav) {
    document
      .querySelector('.o-page-content')
      .classList.add('o-page-content--visible');
    window.onscroll = () => {
      anchorNav.style.top = `${header.getBoundingClientRect().height - 2}px`;
    };

    // eslint-disable-next-line no-unused-vars
    const spy = new Gumshoe('.c-anchornav a', {
      offset() {
        return header.getBoundingClientRect().height + 100;
      },
    });
  }
};

const toggle = () => {
  const anchorNavToggles = document.querySelectorAll('[data-anchor-toggle]');
  const anchorNavScrolls = document.querySelectorAll(
    '.c-anchornav__item [data-scroll]',
  );
  const toggles = [];

  if (anchorNavScrolls.length) {
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < anchorNavScrolls.length; j++) {
      const el = document.getElementById(
        anchorNavScrolls[j].hash.replace('#', ''),
      );
      if (el) {
        toggles.push(el);
      }
    }

    console.log(toggles);
  }

  if (anchorNavToggles.length) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < anchorNavToggles.length; i++) {
      console.log(anchorNavToggles);
      anchorNavToggles[i].onclick = e => {
        e.preventDefault();

        toggles.forEach(toggleEl => {
          toggleEl.classList.toggle('hidden');
        });
      };
    }
  }
};

export default { scroll, scrollspy, toggle };



// WEBPACK FOOTER //
// ./public/wp-content/themes/druckhaus/src/scripts/modules/anchor.js